/**
 * Ryan O'Dowd
 * 2022-09-05
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, colors, globalScale}) => {
  return {
    container: { // @TODO: confirm globalScale here
      flex: 1,
      color: colors.white,
      backgroundColor: colors.primary,
      marginTop: 4,
      marginRight: 8,
      marginBottom: 4,
      marginLeft: 8,
      borderColor: colors.primaryLight,
      borderWidth: globalScale * 4,
      borderRadius: globalScale * 12,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    containerInner: {
      flex: 1,
      width: '100%',
      flexDirection: 'column',
      padding: 12,
    },
    actions: {
      position: 'absolute',
      top: 12,
      right: 12,
      display: 'flex',
      flexDirection: 'row',
    },
    imageWrapper: {
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 8,
    },
    organizationDescriptionPopover: {
      display: 'flex',
      flexGrow: 1,
      flexShrink: 1,
      fontFamily: fonts.primary,
      fontStyle: 'normal', // @TODO: shouldn't need this if fontFamily is set
    },
    organizationLogo: {
      width: 1200,
      height: 100,
    },
    organizationName: {
      width: '100%',
      fontSize: 18,
      color: colors.white,
      fontFamily: fonts.secondaryBold,
    },
    campaignName: {
      width: '100%',
      fontSize: 16,
      color: colors.primaryExtraLight,
      fontFamily: fonts.secondaryBold,
    },
    campaignDescription: {
      width: '100%',
      flexWrap: 'wrap',
      fontSize: 14,
      color: colors.primaryExtraLight,
    },
    icon: {
      fontSize: 22,
      color: colors.white,
    },
    datesWrapper: {
      paddingBottom: 12,
    },
    date: {
      fontSize: 12,
      color: colors.accentLight,
    },
    sectionWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: 12,
      backgroundColor: colors.primaryDark,
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
    },
    lineOne: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    headerText: {
      color: colors.white,
      fontSize: 18,
      fontFamily: fonts.secondaryBold,
    },
    myContributions: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    contributionRow: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    contributionText: {
      color: colors.white,
      fontSize: 16,
    },
    inProgressNumWrapper: {
      backgroundColor: colors.accent,
    },
    numWrinklesWrapper: { // @TODO: confirm globalScale here
      justifyContent: 'center',
      alignItems: 'center',
      margin: 4,
      marginLeft: 8,
      marginRight: 8,
      backgroundColor: colors.complete,
      borderRadius: globalScale * 8,
      minWidth: 28,
      minHeight: 28,
    },
    numWrinklesText: {
      color: colors.primaryExtraDark,
      fontSize: 16,
      fontFamily: fonts.secondaryBold,
    },
    iconParagraphWrapper: { // @TODO: abstract with passage styles
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    passageActionButton: { // @TODO: abstract with passage styles
      display: 'flex',
      marginTop: 0,
      marginRight: 4,
      marginBottom: 0,
      marginLeft: 4,
      borderWidth: 1,
      borderColor: colors.accent,
      backgroundColor: colors.primaryDark,
      opacity: 1,
    },
  };
};

export default getStyles;
